import Shelf from './Shelf';
import Setting from './Setting';
import Bills from './Bills';
import Cart from './Cart';
import SignIn from './SignIn';

export default [Shelf, Setting, Bills, Cart, SignIn];
